import shiftBreakAudit from '@/data/shiftBreak/reducers/shiftBreakAuditReducer';
import shiftBreak from '@/data/shiftBreak/reducers/shiftBreakReducer';

import { combineReducers } from '@reduxjs/toolkit';

export default combineReducers({
  shiftBreak,
  shiftBreakAudit: shiftBreakAudit,
});
